<template>
<v-container class="pa-0">
  <!-- Filters Section -->
  <v-card outlined class="grey lighten-5 pa-4 mb-4 border-dashed">
    <v-row dense>
      <v-col cols="12" md="4">
        <v-select
          v-model="family"
          :items="families"
          item-text="name"
          item-value="id"
          label="Filtrar por Familia"
          placeholder="Todas las Familias"
          outlined
          dense
          clearable
          prepend-inner-icon="fas fa-tags"
          hide-details
          :disabled="loading || families.length == 0"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="line"
          :items="lines"
          item-text="name"
          item-value="id"
          label="Filtrar por Línea"
          placeholder="Todas las Líneas"
          outlined
          dense
          clearable
          prepend-inner-icon="fas fa-stream"
          hide-details
          :disabled="loading || lines.length == 0"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="search"
          @keyup="searchTimeOut"
          label="Buscar por Nombre o SKU"
          outlined
          dense
          prepend-inner-icon="fas fa-search"
          hide-details
          :disabled="loading"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
  </v-card>

  <!-- Products Table -->
  <v-data-table
    :headers="headers"
    :items="products"
    :loading="loading"
    :options.sync="options"
    :server-items-length="total"
    @update:options="fetch"
    class="modern-table border rounded overflow-hidden elevation-0"
    :footer-props="{
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 20, 50]
    }"
  >
    <template v-slot:item.sku="{ item }">
      <span class="font-weight-bold grey--text text--darken-3">{{item.sku}}</span>
    </template>

    <template v-slot:item.name="{ item }">
      <div class="d-flex align-center py-2">
        <v-icon small class="mr-2" color="grey lighten-1">
          {{item.sell_unit_m2 ? 'fas fa-vector-square' : 'fas fa-box'}}
        </v-icon>
        <div class="d-flex flex-column">
          <span class="body-2 font-weight-medium">{{item.name}}</span>
          <span v-if="item.customer_name" class="caption primary--text d-flex align-center">
            <v-icon x-small color="primary" class="mr-1">fas fa-user-tag</v-icon>
            Exclusivo cliente
          </span>
        </div>
      </div>
    </template>

    <template v-slot:item.family_name="{ item }">
      <v-chip x-small outlined label v-if="item.family_name">{{item.family_name}}</v-chip>
    </template>

    <template v-slot:item.line_name="{ item }">
      <v-chip x-small outlined label v-if="item.line_name">{{item.line_name}}</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn small color="success" icon @click="add(item)" title="Agregar a la cotización">
        <v-icon small>fas fa-cart-plus</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</v-container>
</template>

<script>
import {fetchProducts, fetchFamily, fetchLines} from '@/api/products'
import notifications from '@/utils/notifications'

export default {
  name: 'AddProduct',
  props: ['customer'],
  data: () => ({
    products: [],
    search: '',
    timer: null,
    options: {},
    total: 0,
    loading: false,
    lines: [],
    families: [],
    family: '',
    line: '',
    headers: [
      { text: 'Código', value: 'sku', align: 'start', width: '150' },
      { text: 'Descripción', value: 'name', align: 'start' },
      { text: 'Familia', value: 'family_name', align: 'start', width: '150' },
      { text: 'Línea', value: 'line_name', align: 'start', width: '150' },
      { text: 'Acción', value: 'actions', align: 'center', sortable: false, width: '80' }
    ],
  }),
  methods: {
    add(item) {
      this.$emit('add', item)
      this.search = ''
      this.family = ''
      this.line = ''
      this.$emit('close')
    },
    async fetch() {
      if (this.loading) return
      this.loading = true
      
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      let sort = ''
      if (sortBy && sortBy.length > 0) {
        if (sortBy[0] == 'family_name') sort = 'family__name'
        else if (sortBy[0] == 'line_name') sort = 'line__name'
        else if (sortBy[0] == 'customer_name') sort = 'customer__name'
        else sort = sortBy[0]
        
        if (sortDesc[0]) sort = '-' + sort
      }

      const customer_and_null = this.customer ? this.customer.id : 0
      const query = `ordering=${sort}&page=${page || 1}&page_size=${itemsPerPage || 10}&search=${this.search || ''}&family=${this.family || ''}&line=${this.line || ''}&customer_and_null=${customer_and_null}&status=true`
      
      await fetchProducts(query)
      .then((data) => {
        this.total = data.count
        this.products = data.results
      })
      .catch((err) => {
        notifications.showError('Error cargando productos ' + err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    searchTimeOut() {  
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.options.page = 1
        this.fetch()
      }, 800)
    }
  },
  watch: {
    family() {
      this.options.page = 1
      this.fetch()
    },
    line() {
      this.options.page = 1
      this.fetch()
    },
    customer() {
      this.options.page = 1
      this.fetch()
    }
  },
  async mounted() {
    this.families = this.$store.getters.getFamilies
    this.lines = this.$store.getters.getLines
    this.fetch()
  }
}
</script>

<style scoped>
.border-dashed {
  border-style: dashed !important;
  border-width: 1px !important;
}
</style>